import type { ComponentType } from 'react';
import type { PopulationBlob } from './blobLoader';
import type { AttributeKind } from './attributes';
import type { Widget } from './dashboards';
import KpiCard from '../components/charts/KpiCard';
import BarChartCard from '../components/charts/BarChart';
import Histogram from '../components/charts/Histogram';
import MarkdownCard from '../components/charts/MarkdownCard';

export type ChartSlot = {
  name: string;
  accepts: AttributeKind[];
};

export type ChartRenderProps = {
  blob: PopulationBlob;
  indices: Uint32Array;
  slots: Record<string, string | null>;
  widget: Widget;
  dashboardId: string;
};

export type ChartRenderer = ComponentType<ChartRenderProps>;

export type ChartType = {
  id: string;
  label: string;
  slots: ChartSlot[];
  render: ChartRenderer | null;
  requiresData?: boolean;
};

export const CHART_TYPES: ChartType[] = [
  {
    id: 'kpi',
    label: 'KPI count',
    slots: [],
    render: KpiCard,
  },
  {
    id: 'bar',
    label: 'Bar chart',
    slots: [{ name: 'groupBy', accepts: ['categorical', 'ordinal'] }],
    render: BarChartCard,
  },
  {
    id: 'histogram',
    label: 'Histogram',
    slots: [{ name: 'value', accepts: ['ordinal'] }],
    render: Histogram,
  },
  {
    id: 'markdown',
    label: 'Markdown note',
    slots: [],
    render: MarkdownCard,
    requiresData: false,
  },
];

export const CHART_TYPES_BY_ID: Record<string, ChartType> = Object.fromEntries(
  CHART_TYPES.map((c) => [c.id, c]),
);

export function getChartType(id: string): ChartType | undefined {
  return CHART_TYPES_BY_ID[id];
}
